import * as _ from 'lodash';
import type { VoidFunctionComponent } from 'react';
import type { Simplify } from 'type-fest';

import Button from '../../generic/Button/Button';
import { BUTTON_TYPE } from '../../generic/Button/button-constants';

import BaseToast from './BaseToast';
import type { BaseToastProps } from './BaseToast';

type Props = Simplify<BaseToastProps & {
  action: {
    text: string;
    onAction: () => void;
  }
}>;

/*
 * An ActionToast displays normal Toast content along with a customizable Button. The Button will execute a provided callback
 * function and the button's text can be configured.
 * NOTE: This Toast should not be used directly. Please create Toasts through the addToast function.
 */
const ActionToast: VoidFunctionComponent<Props> = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <BaseToast {...(_.omit(props, 'action'))}>
    <Button onClick={props.action.onAction} type={BUTTON_TYPE.OUTLINE}>
      {props.action.text}
    </Button>
  </BaseToast>
);

export default ActionToast;
